"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalAPITranslation = void 0;
const core_1 = require("@angular/core");
const api_1 = require("../../../@shared-types/api");
let ExternalAPITranslation = class ExternalAPITranslation {
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", typeof (_a = typeof api_1.EExternalAPI !== "undefined" && api_1.EExternalAPI) === "function" ? _a : Object)
], ExternalAPITranslation.prototype, "api", void 0);
ExternalAPITranslation = __decorate([
    (0, core_1.Component)({
        selector: 'external-api',
        template: `
    <ng-container>
    {templateType, select,
      mobile-seller {Mobile.de}
      autoscout24 {AutoScout24}
    }
  </ng-container>
  `,
    })
], ExternalAPITranslation);
exports.ExternalAPITranslation = ExternalAPITranslation;
